<template>
    <div class="container-fluid">
        <!-- control the device display globally -->
        <div class="row">
            <div class="offset-lg-2 col-lg-8 col-12">
                
                <!-- show saved items -->
                <template v-if="theItemsForLater">
                    <div class="row mt-3 mb-n2">
                        <div class="col-xl-9 col-md-8 col-sm-6 col-12">
                            <h4><i class="fas fa-save"></i> <span class="text-dark-green">My Saved Items</span></h4>
                        </div>
                        <div class="col-xl-3 col-md-4 col-sm-6 col-12 text-right d-none d-sm-block">
                            <router-link :to="{ name: 'home' }" class="btn btn-dark-green form-control form-control-lg">
                                Continue Shopping
                            </router-link>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <div class="row">
                                <app-item 
                                    v-for="(item, index) in theItemsForLater" 
                                    :key="index" :item="item" 
                                ></app-item>
                            </div>
                        </div>
                    </div>
                </template>
                
                <!-- show empty saved for later message -->
                <template v-else>
                    <div class="row">
                        <div class="col-12 mt-3 text-center">
                            <p class="text-danger fa-lg float-sm-left py-2 mb-sm-0">
                                <i class="fas fa-save d-none d-sm-inline"></i>
                                Your saved items list is empty!
                            </p>
                            <router-link :to="{ name: 'home' }" class="btn btn-dark-green float-sm-right">
                                Continue Shopping
                            </router-link>
                        </div>
                    </div>
                </template>

                <!-- explore categories -->
                <div class="my-5">
                    <app-more-categories :displayedCategory="'none'"></app-more-categories>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import Item from '../shared/Item.vue';
import MoreCategories from './itemDetailsParts/MoreCategories.vue';
import LayoutGeneral from '@/layouts/General.vue'

export default {
    name: "SavedForLater",
    methods: {
        ...mapActions(['fetchSavedLaterItemsAction']),
        fetchSavedLaterItemsFxn() {
            let savedLaterObj = {
                items: []
            }
            
            // obtain the saved-later-items from local-storage and updated saved later obj
            let localStorageSFLItemIds = JSON.parse(localStorage.getItem('ani_items_sfl')) 
            if(localStorageSFLItemIds) {
                savedLaterObj.items = localStorageSFLItemIds
            } 
            this.fetchSavedLaterItemsAction(savedLaterObj).then(() => {}).catch((e) => {})
        },
    },
    computed: {
        ...mapGetters(['itemsForLater']),
        theItemsForLater() {
            if(this.itemsForLater){
                return this.itemsForLater
            }
            return false
        },
    },
    components: {
        appItem: Item,
        appMoreCategories: MoreCategories
    },
    created() {
        this.fetchSavedLaterItemsFxn()
        this.$emit('update:layout', LayoutGeneral);
    }
}
</script>